import React from "react";
import { Not } from "../styled/dashboard";
import { IoNotificationsOffOutline } from "react-icons/io5";

const NotData = ({ message }) => {
  return (
    <Not>
      <IoNotificationsOffOutline />
      <span>{message}</span>
    </Not>
  );
};

export default NotData;
